import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import { ContactDataModel, ContactModel, DataViewEnum, ColumnModel } from '../models';
import { setFormattedData, addOrUpdateData } from '../helpers/helper';

export interface ContactState {
  dataView: DataViewEnum;
  data: ContactDataModel;
}

const initialState: ContactState = {
  dataView: DataViewEnum.List,

  data: {
    recordCount: 0,
    records: [],
    rawData: [],
    columns: []
  },
};

const uniqueDataKey = "contactId";

const columnConfig: Record<string, Partial<ColumnModel>> = {
  primaryKeyId: {
      width: 60,
      formatter: (record: ContactModel) => record.contactId
  },
  firstName: { width: 200 },
  middleName: { width: 200 },
  lastName: { width: 200 },
  position: { width: 200 },
  phone: { width: 180 },
  email: { width: 200 },
  isMainContact: {
    hasTooltip: true,
    flexGrow: 1
  },
};

export const contactsSlice = createSlice({
  name: 'contacts',
  initialState,
  reducers: {
    setDataView: (state, action: PayloadAction<DataViewEnum>) => {
      state.dataView = action.payload;
      return state;
    },
    setContactsData: (state, action: PayloadAction<ContactModel[]>) => {
      state.data = setFormattedData({ rawData: action.payload }, columnConfig, uniqueDataKey);
    },
    setContact: (state, action: PayloadAction<ContactModel>) => {
      addOrUpdateData(state.data, action.payload, columnConfig, uniqueDataKey);
      return state;
    },
    removeContact: (state, action: PayloadAction<number>) => {
      state.data.records = state.data.records.filter(record => record[uniqueDataKey] !== action.payload);
      state.data.rawData = state.data.rawData.filter(raw => raw[uniqueDataKey] !== action.payload);
      return state
    },
    setLogoutContacts: (state) => {
      state = initialState;
      return state;
    },
  },
});

export const { setDataView, setContactsData, setContact, removeContact, setLogoutContacts } = contactsSlice.actions;

export default contactsSlice.reducer;